import { gql } from '@apollo/client'
import { pick } from 'ramda'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { useWidget, useWidgetState } from '../../../WidgetWrapper'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useAverageEventsAmountByPeriodState = () => React.useContext(Context)
export const useAverageEventsAmountByPeriod = () => useAverageEventsAmountByPeriodState()?.averageEventsAmountByPeriod

const QUERY = gql`
  query AverageEventsAmountByPeriod($filter: AverageEventsAmountByPeriodFilter) {
    averageEventsAmountByPeriod(filter: $filter) {
      label
      count
      percentage
    }
  }
`

const AverageEventsAmountByPeriodLoader = ({ children }) => {
  const filter = useCleanFilterForRequest() || {}
  const { value } = useWidgetState()
  const widget = useWidget()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        statusIds: 5,
        periodType: widget.data?.periodType,
        ...pick(['placeIds', 'placeLevelIds', 'userIds', 'checklistIds', 'date'], filter)
      }
    },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AverageEventsAmountByPeriodLoader
